import { useState, useCallback, useEffect } from 'react';
import { API_ENDPOINTS } from '../config';
import { GRAD } from '../lib/brand';

const STORAGE_KEY = 'landing_config_v1';

export const defaultLandingConfig = {
  logos: [
    { id: 'l1', name: 'Nike',        imageUrl: '', active: true, order: 0 },
    { id: 'l2', name: 'Adidas',      imageUrl: '', active: true, order: 1 },
    { id: 'l3', name: 'iShop',       imageUrl: '', active: true, order: 2 },
    { id: 'l4', name: 'Cole Haan',   imageUrl: '', active: true, order: 3 },
    { id: 'l5', name: 'Birkenstock', imageUrl: '', active: true, order: 4 },
  ],
  cards: [
    { id: 'c1', label: 'Nike',      title: '20% de Descuento', subtitle: 'ADICIONAL', buttonText: 'ACCEDER', baseColor: '#1A1A1A', route: '/signup',          imageUrl: '', layout: 'A' },
    { id: 'c2', label: 'Cole Haan', title: '15% de Descuento', subtitle: 'ADICIONAL', buttonText: 'VER BENEFICIOS',  baseColor: '#2563EB', route: '/stores-preview',  imageUrl: '', layout: 'B' },
  ],
  texts: {
    heroTitle:    'PRECIOS\nOCULTOS',
    heroSubtitle: 'Accede a descuentos exclusivos en las mejores marcas del outlet.',
    heroCTA:      '¡ PAGA MENOS !',
    footerCTA:    '¿Ya eres Miembro? Acceder',
  },
  textBlocks: [],
  navCTA: {
    text:  '¡Paga menos!',
    /* Era '#FF5252', el rojo del sistema anterior. El botón de la barra es el
       CTA principal del landing y va con el degradado vivo del manual
       (BRAND.md §6). Sigue siendo editable desde el admin; esto es solo el
       valor por omisión cuando nadie lo ha tocado. */
    color: GRAD.vivo,
    /* Era '#mp-pricing', el ancla de la sección de precio; al retirarla, ese
       destino dejó de existir y el botón no hacía nada. Ahora va a los
       beneficios, como el resto de los CTA de la página. */
    route: '/beneficios',
  },
};

export const defaultSections = [
  {
    id: 's-hero',
    type: 'hero',
    visible: true,
    order: 0,
    data: {
      heroTitle:    'PRECIOS\nOCULTOS',
      heroSubtitle: 'Accede a descuentos exclusivos en las mejores marcas del outlet.',
      heroCTA:      '¡ PAGA MENOS !',
      footerCTA:    '¿Ya eres Miembro? Acceder',
    },
  },
  {
    id: 's-discounts',
    type: 'discount_carousel',
    visible: true,
    order: 1,
    data: {
      /* Era «Descuentos», y estaba escrito dentro del componente. Iván lo quiso
         cambiar y editable (30-ago-2026). Las tarjetas siguen viniendo de la
         base; lo editable es el encabezado y el orden se arrastra en
         «Beneficios». */
      label: 'Lo que vondi te da',
    },
  },
  /* La sección "Destacados" (promo_carousel) se retiró el 11-ago-2026: llevaba
     apagada en producción (visible: false) y su tarjeta era una cuarta variante
     del mismo molde que ya cubre la flip card. */
  {
    id: 's-marquee',
    type: 'marquee',
    visible: true,
    order: 3,
    data: {
      logos: [
        { id: 'l1', name: 'Nike',        imageUrl: '', active: true, order: 0 },
        { id: 'l2', name: 'Adidas',      imageUrl: '', active: true, order: 1 },
        { id: 'l3', name: 'iShop',       imageUrl: '', active: true, order: 2 },
        { id: 'l4', name: 'Cole Haan',   imageUrl: '', active: true, order: 3 },
        { id: 'l5', name: 'Birkenstock', imageUrl: '', active: true, order: 4 },
      ],
    },
  },
  {
    id: 's-pay-less',
    type: 'pay_less_intro',
    visible: true,
    order: 4,
    data: {
      title:          'Hoy puedes pagar menos.',
      subtitle:       'Cada una de tus marcas favoritas tiene su propio beneficio exclusivo para ti',
      quoteText:      'El precio esta especialmente diseñado, para que con tu primera compra te ahorres mas de lo que te cuesta el acceso.',
      quoteButtonText:'ACCEDER',
    },
  },
  {
    id: 's-how',
    type: 'how_it_works',
    visible: true,
    order: 5,
    data: {
      steps: [
        { n: 1, t: 'Regístrate y elige tu plan', d: 'Anual $650 o mensual $277. Todos los beneficios incluidos. Cancelas cuando quieras.' },
        { n: 2, t: 'Genera tu QR personal',      d: 'Tarjeta digital única con tiempo de expiración. Solo tú la puedes generar.' },
        { n: 3, t: 'La tienda valida y listo',   d: 'El staff escanea, elige el beneficio y se canjea. Sin trámites adicionales.' },
      ],
      /* La descripción de qué es vondi, editable desde el admin. */
      descripcion: 'Es un acceso el cual va a hacer que te ahorres mas dinero de lo que ya ibas a pagar, al acceder, tendrás acceso a vondi donde se te generará una tarjeta digital personal única (QR) con la cual la tienda podrá hacerte válido el beneficio exclusivo. Hoy en día vondi opera en Outlet Puebla. A partir del momento en donde pagas tu acceso tienes 1 mes de acceso, 7 días antes de la renovación te llegará un correo para que puedas cancelar o continuar.',
    },
  },
  {
    id: 's-calculator',
    type: 'savings_calculator',
    visible: true,
    order: 6,
    data: {
      titulo: 'Calcula si te conviene comprar vondi',
      subtitulo: 'Suma las tiendas donde vas a comprar y compáralo con lo que cuesta el acceso.',
      /* El muestrario de precios se pinta dentro de esta sección, así que sus
         textos se editan aquí mismo. */
      muestrarioTitulo: 'Ejemplo de productos y precios reales',
      muestrarioSubtitulo: '',
    },
  },
  {
    id: 's-cta-ready',
    type: 'cta_ready',
    visible: true,
    order: 7,
    data: {
      title:      '¿Estás listo?',
      buttonText: 'Acceder',
    },
  },
  /*
    La sección `pricing` se retiró de los valores por omisión (Iván,
    13-ago-2026). Iba en el `order: 8`, es decir **después** del CTA de
    «Acceder», y era lo último que veía quien bajaba hasta el final: el precio
    a bocajarro, sin nada después. Quitándola, la página cierra con el botón.

    Se quita de aquí además de ocultarla en la configuración guardada, porque
    si no un despliegue con la base limpia la traería de vuelta.
  */
];

function readConfig() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      return {
        logos:      parsed.logos      ?? defaultLandingConfig.logos,
        cards:      parsed.cards      ?? defaultLandingConfig.cards,
        texts:      parsed.texts      ?? defaultLandingConfig.texts,
        textBlocks: parsed.textBlocks ?? [],
        sections:   parsed.sections   ?? defaultSections,
        navCTA:     parsed.navCTA     ?? defaultLandingConfig.navCTA,
      };
    }
  } catch { /* ignore */ }
  return { ...defaultLandingConfig, sections: defaultSections };
}

export function useLandingConfig() {
  const [config, setConfig]   = useState(readConfig);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    fetch(API_ENDPOINTS.LANDING_CONFIG)
      .then(r => r.json())
      .then(data => {
        if (data?.success && data?.data) {
          const d = data.data;
          setConfig({
            logos:      d.logos      ?? defaultLandingConfig.logos,
            cards:      d.cards      ?? defaultLandingConfig.cards,
            texts:      d.texts      ?? defaultLandingConfig.texts,
            textBlocks: d.textBlocks ?? [],
            sections:   d.sections   ?? defaultSections,
            navCTA:     d.navCTA     ?? defaultLandingConfig.navCTA,
          });
        }
      })
      .catch(() => setError('No se pudo cargar la config del servidor'))
      .finally(() => setLoading(false));
  }, []);

  const updateConfig = useCallback((patch) => {
    setConfig(prev => ({ ...prev, ...patch }));
  }, []);

  const resetConfig = useCallback(() => {
    try { localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
    setConfig({ ...defaultLandingConfig, sections: defaultSections });
  }, []);

  return { config, updateConfig, resetConfig, loading, error };
}

export async function saveToServer(config) {
  try {
    const token = localStorage.getItem('auth_token');
    const res = await fetch(API_ENDPOINTS.ADMIN_LANDING_CONFIG, {
      method:  'PUT',
      headers: {
        'Content-Type':  'application/json',
        'Accept':        'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(config),
    });
    const data = await res.json();
    if (data?.success) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(config)); } catch { /* ignore */ }
      return { success: true };
    }
    return { success: false, error: data?.message ?? 'Error al guardar' };
  } catch (e) {
    return { success: false, error: e.message ?? 'Error de red' };
  }
}

export function getLandingConfigStatic() {
  return readConfig();
}

export function getContrastColor(hex) {
  if (!hex || hex.length < 7) return '#FFFFFF';
  try {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.55 ? '#000000' : '#FFFFFF';
  } catch {
    return '#FFFFFF';
  }
}
